import React, {useMemo, useState} from "react";
import {ComponentPropsFromRoute} from "../../../../routers/routers";
import {useTranslate} from "../../../../hooks/translate.hook";
import {columnsFactory} from "./agent.data.statements.columns";
import FilteredTable from "../../../common/filtered-table/filtered.table";
import {FilterDataHandler} from "../../../../models/filter/filter.data.handler";
import {useRequiredStore} from "../../../../utils/store";
import {AgentDataStoreContext} from "../agent.data.store";
import {StatementFile} from "../../../../models/accounting/client-statements";
import {notifications} from "../../../../services/notifications/notifications";
import {statementsFilesService} from "../../../../services/accounting/client-statement-files.service";
import {RootStoreContext} from "../../../../stores/root/root.store";

interface StatementsFileListProps extends ComponentPropsFromRoute {}

export const AgentDataStatementsFileList: React.FC<StatementsFileListProps> = () => {

    const {account} = useRequiredStore(AgentDataStoreContext);
    const t = useTranslate();
    const [loading, setLoading] = useState<boolean>(false);
    const {authStore: { generateUri }} = useRequiredStore(RootStoreContext);

    const reload = async (statement: StatementFile) => {
        setLoading(true);
        try {
            await statementsFilesService.reload(statement);
            notifications.successfully();
        } finally {
            setLoading(false)
        }
    }

    const dataHandler: FilterDataHandler<StatementFile> = useMemo(() => new FilterDataHandler(request => statementsFilesService.getAllByAccount(request, account!.id)), []);
    const columns = useMemo(() => columnsFactory(t, reload, loading, generateUri), [loading]);

    return (
        <>
            <FilteredTable
                columns={columns}
                dataHandler={dataHandler}
            />
        </>
    )
}